"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayjs = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
const localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
dayjs_1.default.extend(isBetween_1.default);
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
exports.dayjs = dayjs_1.default;
//# sourceMappingURL=dayjs.js.map